export const ECGDeviceTypes = {
    unknown: 'unknown',
    samsung: 'samsung_watch',
    apple: 'apple_watch',
    spatch: 'spatch',
}

export const brands = {
    apple: 'apple',
    samsung: 'samsung',
    wellysis: 'wellysis',
    nurvv: 'nurvv',
    prevayl: 'prevayl',
    kiosk: 'kiosk',
}

export const signalOptions = [
    {value: 'like', label: 'Like'},
    {value: 'dislike', label: 'Dislike'},
]
